import { useTranslation } from 'react-i18next'
import {
  Calendar,
  ClipboardCheck,
  GitBranch,
  Link2,
  Grid3x3,
  Settings,
  TrendingUp,
  Users,
} from 'lucide-react'
import type { NavItem } from '@ludus/ui'

export function useConsoleNavItems(): NavItem[] {
  const { t } = useTranslation()
  return [
    { key: 'pipelines', label: t('nav.pipelines'), path: '/pipelines', icon: GitBranch },
    { key: 'sales', label: t('nav.sales'), path: '/sales', icon: Link2 },
    { key: 'audits', label: t('nav.audits'), path: '/audits', icon: ClipboardCheck },
    { key: 'managers', label: t('nav.managers'), path: '/managers', icon: Users },
    { key: 'calendar', label: t('nav.calendar'), path: '/calendar', icon: Calendar },
    { key: 'matrix', label: t('nav.matrix'), path: '/matrix', icon: Grid3x3 },
    { key: 'forecasts', label: t('nav.forecasts'), path: '/forecasts', icon: TrendingUp },
    { key: 'settings', label: t('nav.settings'), path: '/settings', icon: Settings },
  ]
}
